export const contactInformation = {
    primaryPhone: '+38 (098) 211 76 90',
    email: 'obmer@clearline.com.ua',
}
